import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import {
    USER__SET_DETAILS,
    USER__SET_SUBSCRIPTION,
    USER__SET_SUBSCRIPTION_CONSTRAINTS,
    USER__SET_NOTIFICATIONS,
    USER__SET_TRIAL_COUNT,
} from '../store/actions'
import { API__USER } from '../api'

import MainWrapper from './wrappers/main'
import EditorWrapper from './wrappers/editor'

import MyProjects from '../pages/MyProjects/MyProjects'
import ProjectAnalytics from '../pages/ProjectAnalytics/ProjectAnalytics'
import AccountSettings from '../pages/AccountSettings/AccountSettings'
import BillingAndPayments from '../pages/BillingAndPayments/BillingAndPayments'
import Editor from '../pages/Editor'
import BlockEditor from '../pages/BlockEditor'
import Loader from '../components/Loader'
import Toast from '../common/components/Toast/Toast'
import UserRoleModal from '../common/components/Modal/UserRoleModal/UserRoleModal'
import TrialExtensionModal from '../common/components/Modal/TrialExtensionModal/TrialExtensionModal'
import { EDUCATION_GROUP_ID } from '../common/constants/ProductConstants'

class MainRoutes extends React.Component {
    _isMounted = false

    state = {
        is_loading: true,
        isOpenedRoleModal: false,
        isOpenedTrialModal: false,
    }

    async componentDidMount() {
        this._isMounted = true
        try {
            const { is_auth } = this.props

            if (is_auth) {
                if (!this.props.user_details) {
                    const { user, P__USER__SET_DETAILS } = this.props
                    const response_1 = await API__USER.GET_DETAILS(user.id)
                    await P__USER__SET_DETAILS(response_1)
                }
                if (!this.props.user_subscription) {
                    const { user, P__USER__SET_SUBSCRIPTION } = this.props
                    const response_2 = await API__USER.GET_SELECTED_SUBSCRIPTION(user.id)
                    await P__USER__SET_SUBSCRIPTION(response_2)
                }
                if (!this.props.user_subscription_constraints) {
                    const { user_subscription, P__USER__SET_SUBSCRIPTION_CONSTRAINTS } = this.props
                    const response_3 = await API__USER.GET_SUBSCRIPTION_CONSTRAINTS(user_subscription.id)
                    await P__USER__SET_SUBSCRIPTION_CONSTRAINTS(response_3)
                }
                if (!this.props.notifications) {
                    const { user, P__USER__SET_NOTIFICATIONS } = this.props
                    const response_4 = await API__USER.GET_NOTIFICATIONS(user.id)
                    await P__USER__SET_NOTIFICATIONS(response_4)
                }
                if (!this.props.user_trial_count) {
                    const { user, P__USER__SET_TRIAL_COUNT } = this.props
                    const response_5 = await API__USER.GET_TRIAL_COUNT(user.id)
                    await P__USER__SET_TRIAL_COUNT(response_5)
                }

                const { user_details } = this.props
                if (!user_details.roleInProjectDto) this.setState({ isOpenedRoleModal: true })
            }
        } catch (err) {
            console.error(err)
        } finally {
            if (this._isMounted) {
                await this.setState({
                    is_loading: false,
                })
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    updateUserRole = async data => {
        try {
            const { user, P__USER__SET_DETAILS } = this.props
            const userDetails = await API__USER.GET_DETAILS(user.id)
            const updatedUser = await API__USER.UPDATE_DETAILS(userDetails.id, {
                ...userDetails,
                roleInProjectDto: {
                    ...data.role,
                    userGroupInProjectDto: data.group,
                },
            })
            P__USER__SET_DETAILS(updatedUser)
        } catch (err) {
            console.error(err)
            Toast('error', {})
        }
    }

    onSelectUserRole = async data => {
        await this.updateUserRole(data)
        this.setState({ isOpenedTrialModal: true })
    }

    isEducation = userDetails => {
        if (userDetails) {
            return userDetails.roleInProjectDto
                ? userDetails.roleInProjectDto.userGroupInProjectDto.customId === EDUCATION_GROUP_ID
                : null
        }
        return null
    }

    render() {
        const { is_auth, location, user_trial_count: userTrialCount, user_details: userDetails } = this.props
        const { is_loading, isOpenedRoleModal, isOpenedTrialModal } = this.state
        const isEducation = this.isEducation(userDetails)

        return is_auth ? (
            !is_loading ? (
                // <Suspense fallback={<></>}>
                <>
                    <EditorWrapper path="/editor/:projectId?" component={BlockEditor} />

                    <MainWrapper exact path="/account/settings" component={AccountSettings} />
                    <MainWrapper exact path="/account/billing-and-payments" component={BillingAndPayments} />
                    <MainWrapper exact path="/account/my-projects" component={MyProjects} />
                    <MainWrapper path="/account/my-projects/:id/analytics" component={ProjectAnalytics} />

                    {/*<Route path="/oauth2/successful-registration" component={OauthRegSuccess} />*/}

                    <EditorWrapper path="/account/editor" component={Editor} />

                    {isOpenedRoleModal && (
                        <UserRoleModal
                            isEditMode={false}
                            onSelect={async data => await this.onSelectUserRole(data)}
                            onClose={() => this.setState({ isOpenedRoleModal: false })}
                        />
                    )}
                    {isOpenedTrialModal && (
                        <TrialExtensionModal
                            onClose={() => this.setState({ isOpenedTrialModal: false })}
                            trialCount={userTrialCount}
                            isEducation={isEducation}
                        />
                    )}
                </>
            ) : (
                // </Suspense>
                <Loader text="Protected route loading..." />
            )
        ) : (
            <Redirect to={{ pathname: '/auth', state: { from: location } }} />
        )
    }
}

const mapStateToProps = state => {
    return {
        is_auth: state.is_auth,
        user: state.user,
        user_details: state.user_details,
        user_subscription: state.user_subscription,
        user_subscription_constraints: state.user_subscription_constraints,
        user_notifications: state.user_notifications,
        user_trial_count: state.user_trial_count,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        P__USER__SET_DETAILS: obj => dispatch(USER__SET_DETAILS(obj)),
        P__USER__SET_SUBSCRIPTION: obj => dispatch(USER__SET_SUBSCRIPTION(obj)),
        P__USER__SET_SUBSCRIPTION_CONSTRAINTS: obj => dispatch(USER__SET_SUBSCRIPTION_CONSTRAINTS(obj)),
        P__USER__SET_NOTIFICATIONS: obj => dispatch(USER__SET_NOTIFICATIONS(obj)),
        P__USER__SET_TRIAL_COUNT: obj => dispatch(USER__SET_TRIAL_COUNT(obj)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainRoutes)
